import { HrmsType } from "./hrmsTypes";

export const hrmsReducer = {
  resetHrmsError: (state: HrmsType) => {
    state.error = null;
  },
  resetHrmsSuccess: (state: HrmsType) => {
    state.success = null;
  },
  resetHrmsFetching: (state: HrmsType) => {
    state.fetching = false;
  },
  resetHrmsMessage: (state: HrmsType) => {
    state.message = "";
  },
  resetHrmsStatusCode: (state: HrmsType) => {
    state.statusCode = null;
  },
  resetOpenPoisitionList: (state: HrmsType) => {
    state.openPoisitionList = [];
  },
  resetOpenPositionTotalCount: (state: HrmsType) => {
    state.openPositionTotalCount = 0;
  },
  resetRecruitmentTrackerList: (state: HrmsType) => {
    state.recruitmentTrackerList = [];
  },
  resetRecruitmentTrackerTotalCount: (state: HrmsType) => {
    state.recruitmentTrackerTotalCount = 0;
  },
  resetSingleRecruitmentTrackerList: (state: HrmsType) => {
    state.singleRecruitmentTrackerList = [];
  },
  resetUniqueCheckFetching: (state: HrmsType) => {
    state.uniqueCheckFetching = false;
  },
  resetUniqueCheckMessage: (state: HrmsType) => {
    state.uniqueCheckMessage = "";
  },
  resetApprovalList: (state: HrmsType) => {
    state.approvalList = [];
  },
  resetRecruitmentTrackerStageCountList: (state: HrmsType) => {
    state.recruitmentTrackerStageCount = [];
  },
  resetHrmsBulkUpload: (state: HrmsType) => {
    state.hrmsBulkUploadData = {};
  },
  resetBulkUploadHistoryCount: (state: HrmsType) => {
    state.bulkUploadHistoryCount = 0;
  },
  resetBulkUploadHistoryData: (state: HrmsType) => {
    state.bulkUploadHistoryData = [];
  }
};
